<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Document List</h2>
          </div>
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-between pb-2 pt-0"
            >
              <div class="d-md-flex justify-content-between">
                <div class="mr-0 mr-md-3 action-top-search">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search Document"
                      aria-label="Search Document"
                      aria-describedby="search-Document"
                      v-model="searchText"
                      v-on:keyup.enter="refreshPartnerTable"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text" id="search-mail">
                        <i class="icon-magnifier"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-md-flex justify-content-between">
                <b-button
                  size="lg"
                  variant="primary btn-mw"
                  @click="addDocument()"
                >
                  Add New
                  <i class="fa fa-plus-square"></i>
                </b-button>
              </div>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 d-flex align-items-center justify-content-end table-pagination"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- Share and Save Coupon Listing -->
            <b-table
              responsive
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(slno)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(file_name)="data">
                <i
                  class="fa fa-file-word-o"
                  v-if="data.item.file_type == 'word'"
                ></i>
                <i
                  class="fa fa-file-excel-o"
                  v-else-if="data.item.file_type == 'excel'"
                ></i>
                <i
                  class="fa fa-file-image-o"
                  v-else-if="data.item.file_type == 'image'"
                ></i>
                <i class="fa fa-file" v-else></i>
                {{ data.value }}
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  size="sm"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="editDocument()">
                    Edit
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 d-flex align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DocumentListcomponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
  },
  data() {
    return {
      items: [
        {
          document_title: "Project Overview Summary",
          file_name: "summary.txt",
          file_type: "txt",
        },
        {
          document_title: "Web icon",
          file_name: "logo.jpeg",
          file_type: "image",
        },
        {
          document_title: "Quarterly Sales Analysis",
          file_name: "sales-report.xls",
          file_type: "excel",
        },
        {
          document_title: "Team Meeting Notes",
          file_name: "notes.docx",
          file_type: "word",
        },
      ],

      fields: [
        {
          key: "slno",
          label: "Sl No",
          sortable: true,
          thStyle: { width: "5%" },
          thClass: "th_sortfix",
        },
        {
          key: "document_title",
          label: "Document Title",
          thClass: "th_sortfix",
        },
        { key: "file_name", label: "File Name", thClass: "th_sortfix" },
        {
          key: "action",
          label: "Action",
          sortable: false,
          thClass: "th_sortfix text-right pr-3",
          tdClass: "text-right",
        },
      ],
      searchText: "",

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    addDocument() {
      this.$router.push({ path: "/document-management/add" });
    },
    editDocument() {
      this.$router.push({ path: "/document-management/edit" });
    },
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
  },
  mounted() {
    this.totalRows = this.items.length;
  },
};
</script>
